module.exports = __webpack_public_path__ + "images/903e68a9bb161277d7eb5259eb504d88.png";